import styled from 'styled-components';

import { FontWeight } from 'styles/defaultTheme';

export const IconValueContainer = styled.div`
	margin-bottom: 1rem;
	margin-top: 2rem;
	font-weight: ${FontWeight.bold};
`;
